import IconButton from '@components/IconButton/IconButton'
import { faTrash } from '@fortawesome/pro-solid-svg-icons'
import { Stack, Typography, useTheme } from '@mui/material'
import { TreeItem2, TreeItem2Props } from '@mui/x-tree-view'

type Props = TreeItem2Props & {
	onDelete: (itemId: Id) => void
}

function CustomTreeItemLabel({
	label,
	onDelete,
	itemId,
}: {
	label: string
	onDelete: (itemId: Id) => void
	itemId: string
}) {
	const theme = useTheme()
	return (
		<Stack direction="row" alignItems="center" spacing={1}>
			<Typography variant="body2">{label}</Typography>
			<IconButton
				onClick={() => onDelete(itemId)}
				sx={{ color: theme.palette.error.main, p: 0.5 }}
				icon={faTrash}
				size="small"
				fontSize="1rem"
			/>
		</Stack>
	)
}

export default function CustomTreeItem({ label, onDelete, itemId, children, ...props }: Props) {
	return (
		<TreeItem2
			{...props}
			label={label}
			itemId={itemId}
			slots={{ label: CustomTreeItemLabel }}
			slotProps={{ label: { label, onDelete, itemId } as any }}
		>
			{children}
		</TreeItem2>
	)
}
